import {
  Box,
  Stack,
  Grid2,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  CircularProgress,
  Fade,
  FormHelperText,
  TextField,
  InputAdornment,
  Tooltip,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { GET } from "../../request/service";
import { getDeviceListAndGNSSData } from "../../request/api";
import { useLocation } from "react-router-dom";
import { IconInfoCircle, IconProgressCheck } from "@tabler/icons-react";
import {
  CONSTANT_SET,
  INPUT_TYPE_NAME,
  REPORT_TITLE,
} from "../../constants/dashboard";
import SendIcon from "@mui/icons-material/Send";
import LoadingButton from "@mui/lab/LoadingButton";
import { v4 as uuidv4 } from "uuid";
import axios, { AxiosResponse } from "axios";
import { ThreeDots } from "react-loader-spinner";
import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Device {
  DeviceId: string;
  Name: string;
}

interface Dashboard {
  DashboardId: string;
  Name: string;
}

const messagePage: FC = () => {
  const location = useLocation();
  const [currentDashboard, setCurrentDashboard] = useState("");
  const [dashboardList, setDashboardList] = useState([]);
  const [devices, setDevices] = useState<Device[]>([]);
  const [deviceLoading, setDeviceLoading] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);
  const [optionWidth, setOptionWidth] = useState("300px");
  const [deviceId, setDeviceId] = useState("");
  const [message, setMessage] = useState("");
  const [originMessage, setOriginMessage] = useState("");
  const [messageTitle, setMessageTitle] = useState("");
  const [currentMessageTitle, setCurrentMessageTitle] = useState("");
  const [messageTitleCodeCount, setMessageTitleCodeCount] = useState(0);
  const [messageTitleWidth, setMessageTitleWidth] = useState(
    CONSTANT_SET.MAX_INPUT_WIDTH,
  );
  const [isComposing, setIsComposing] = useState(false);
  const messageTitleTooltip = `
        Title <br>
        Please input 6 characters or 9 letters <br>`;
  const messageTooltip = `
        Message <br>
        Please input 33 characters or 50 letters <br>`;
  const exceptJapaneseOrChineseRegex =
    /[A-Za-z0-9\s\.,!?;:\-\(\)\[\]\{\}"'@#\$%\^&\*]+/g;
  const includeJapaneseOrChineseRegex =
    /[\u3040-\u30FF\u4E00-\u9FFF\uFF01-\uFF5E\u3000]+/g;
  // const regex = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\uFF01-\uFF5E\u3000\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]+/gu;

  const onlyJapaneseOrChineseRegex =
    /^[\u4E00-\u9FFF\u3040-\u30FF\uFF01-\uFF5E]+$/;
  // /^[\u4E00-\u9FAF\u3040-\u30FF\u31F0-\u31FF\uFF66-\uFF9F]+$/;

  const [openLoading, setOpenLoading] = React.useState(false);
  const [showSuccessIcon, setShowSuccessIcon] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const dashboardStorageList = JSON.parse(
    localStorage.getItem("dashboardList") || "[]",
  );
  const [isMessagePaste, setIsMessagePaste] = React.useState(false);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [messageMaxLength, setMessageMaxLength] = useState(50);
  const hasRun = useRef(false);

  const handleChange = async (event: SelectChangeEvent) => {
    setCurrentDashboard(event.target.value);
    setDevices([]);
    setDeviceId("");
    setMessageTitle("");
    setMessage("");
    await getDashboardDeviceData(event.target.value);
  };

  useEffect(() => {
    if (hasRun.current) return;
    if (dashboardStorageList && dashboardStorageList.length > 0) {
      let autoWidth = 0;
      dashboardStorageList.map((dashboard: Dashboard) => {
        dashboard.Name.length > autoWidth
          ? (autoWidth = dashboard.Name.length)
          : null;
      });
      resetDashboardList();
      setDashboardList(dashboardStorageList);
      setCurrentDashboard(dashboardStorageList[0].DashboardId);
      setOptionWidth(autoWidth * 9.5 + "px");
      getDashboardDeviceData(dashboardStorageList[0].DashboardId);
      hasRun.current = true;
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   let autoWidth = 0;
  //   if (dashboardStorageList && dashboardStorageList.length > 0) {
  //     dashboardStorageList.map((dashboard: Dashboard) => {
  //       dashboard.Name.length > autoWidth
  //         ? (autoWidth = dashboard.Name.length)
  //         : null;
  //     });
  //     setCurrentDashboard(dashboardStorageList[0]?.DashboardId);
  //   }
  //   setOptionWidth(autoWidth * 9.5 + "px");
  // }, [optionWidth]);

  useEffect(() => {
    setCurrentMessageTitle(messageTitle);
    const res = checkInputLength(messageTitle, "title");
    res.incommingCharacterCount === 0 ? setIsComposing(false) : null;
  }, [messageTitle]);

  const getDashboardDeviceData = async (dashboardId: string) => {
    setDeviceLoading(true);
    await GET(
      getDeviceListAndGNSSData +
        "?dashboardId=" +
        dashboardId +
        "&date=&deviceId=&deviceMsg=all",
      "",
    ).then((res: any) => {
      console.log(res);
      if (res.deviceList.length > 0) {
        const sortedDevices = [...res.deviceList].sort((x: any, y: any) =>
          x.Name.localeCompare(y.Name, undefined, { sensitivity: "base" }),
        );
        setDevices(sortedDevices);
        setDeviceId(sortedDevices[0].DeviceId);
      } else {
        console.log("No Device List Data!");
        // setAlertMessage("No Device List Data!");
        // setMessageOpen(true);
      }
      setDeviceLoading(false);
    });
  };

  const sendMessage = async () => {
    setShowError(true);
    setShowSuccessIcon(false);
    if (message !== "" && messageTitle !== "") {
      setMessageLoading(true);
      setOpenLoading(true);
      try {
        const newUuid = uuidv4();
        await axios
          .post(
            "https://ywuzgviy74.execute-api.ap-northeast-1.amazonaws.com/dev/sendMessageToDevice",
            {
              bodydata: {
                app: {
                  msg: {
                    id: newUuid,
                    title: messageTitle,
                    text: message,
                    time: dayjs()
                      .tz(dayjs.tz.guess())
                      .format("YYYY-MM-DDTHH:mm:ssZ"),
                  },
                },
              },
              dashboardId: currentDashboard,
              deviceId: deviceId,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("idToken")}`,
              },
            },
          )
          .then((res: AxiosResponse<any, any>) => {
            switch (res.status) {
              case 200:
                setShowSuccessIcon(true);
                setShowError(false);
                setMessageLoading(false);
                setTimeout(() => {
                  setOpenLoading(false);
                }, 2000);
                // setOpenLoading(false);
                return res;
              default:
                console.log("Send Message Failed!");
                break;
            }
          });
      } catch (error) {}
    }
  };

  const resetDashboardList = () => {
    const existingList = document.getElementById("dashboard-select");
    if (
      existingList &&
      existingList.innerHTML === "" &&
      currentDashboard !== ""
    ) {
      setCurrentDashboard("");
    }
  };

  const selectDeviceChange = (event: { target: { value: any } }) => {
    setDeviceId(event.target.value);
    setMessageTitle("");
    setMessage("");
  };

  const calculationMethod = (
    text: string,
    codeCount: number,
    characterCount: number,
    characterStatus: number,
  ) => {
    switch (characterStatus) {
      case 0: {
        const matchResult =
          text.slice(0, -1).match(includeJapaneseOrChineseRegex) || [];
        const width =
          messageTitleWidth -
          matchResult.join("").length * CONSTANT_SET.CHAR_WIDTH;
        const remainingCount =
          Math.floor(width / CONSTANT_SET.LETTER_WIDTH) - codeCount;
        remainingCount >= 0 &&
        remainingCount * CONSTANT_SET.LETTER_WIDTH >= CONSTANT_SET.CHAR_WIDTH
          ? setMessageTitle(text)
          : setMessageTitle(text.slice(0, -1));
        break;
      }
      default: {
        const width =
          messageTitleWidth - characterCount * CONSTANT_SET.CHAR_WIDTH;
        const remainingCount =
          Math.floor(width / CONSTANT_SET.LETTER_WIDTH) - codeCount;
        remainingCount >= 0
          ? setMessageTitle(text)
          : setMessageTitle(text.slice(0, -1));
        break;
      }
    }
  };

  const listeningTitleInputchange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    // setMessageTitle(e.target.value)
    if (messageTitle.length > e.target.value.length) {
      setMessageTitle(e.target.value);
    } else {
      const incommingCharacterCount =
        e.target.value.match(includeJapaneseOrChineseRegex)?.join("").length ||
        0;
      const incomingCodeCount =
        e.target.value.match(exceptJapaneseOrChineseRegex)?.join("").length ||
        0;

      if (
        incommingCharacterCount > 6 ||
        incomingCodeCount > 9 ||
        (incommingCharacterCount === 6 && incomingCodeCount !== 0) ||
        (incommingCharacterCount !== 0 && incomingCodeCount === 9) ||
        incommingCharacterCount * CONSTANT_SET.CHAR_WIDTH +
          incomingCodeCount * CONSTANT_SET.LETTER_WIDTH >
          messageTitleWidth
      ) {
        console.log(e.target.value, "e.target.value ");
        console.log(messageTitle, "messageTitle ");
        // e.preventDefault();
      } else {
        setMessageTitle(e.target.value);
      }
    }
  };

  const handleMessageTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // session1: 输入的title只有 中/日(判断字符长度，无脑添加)， )
    // session2: 输入的title是 中/日+英/字符/数字(1.取中/日，取字符长度算占位宽度*21px，其余字符长度*14px，求和与126取差值
    // session3: 判断最后输入的字符是： 1.中/日 session2的差值/21 向下取整 < 6，添加 2.非中/日 session2的差值/14向下取整 < 9 添加
    // session4: 判断粘贴的值与当前输入的

    // 中/日
    // backspace
    const res = checkInputLength(e.target.value, "title");
    setMessageTitle(e.target.value);
    // if (isComposing && res.incomingCodeCount === 1) {
    if (isComposing) {
      switch (res.incommingCharacterCount) {
        case 0:
          setMessageTitle(e.target.value.slice(0, 9));
          setCurrentMessageTitle(e.target.value.slice(0, 9));
          break;
        case 6:
          setMessageTitle(e.target.value.slice(0, 6));
          setCurrentMessageTitle(e.target.value.slice(0, 6));
          break;
        default:
          const width =
            messageTitleWidth -
            res.incommingCharacterCount * CONSTANT_SET.CHAR_WIDTH;
          const remainingCount = Math.floor(width / CONSTANT_SET.LETTER_WIDTH);
          setMessageTitle(
            e.target.value.slice(
              0,
              remainingCount + res.incommingCharacterCount,
            ),
          );
          setCurrentMessageTitle(
            e.target.value.slice(
              0,
              remainingCount + res.incommingCharacterCount,
            ),
          );
          break;
      }
    } else {
      setMessageTitle(e.target.value);
      if (res.incommingCharacterCount === 0 && res.incomingCodeCount !== 0) {
        setMessageTitle(e.target.value.slice(0, 9));
      } else if (
        res.incommingCharacterCount !== 0 &&
        res.incomingCodeCount === 0
      ) {
        setMessageTitle(e.target.value.slice(0, 6));
      }
    }
  };

  const handleMessageTitlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
  ) => {
    const pasteData = e.clipboardData.getData("text");
    const incommingCharacterCount =
      pasteData.match(includeJapaneseOrChineseRegex)?.join("").length || 0;
    const incomingCodeCount =
      pasteData.match(exceptJapaneseOrChineseRegex)?.join("").length || 0;
    const existCharacterCount =
      messageTitle.match(includeJapaneseOrChineseRegex)?.join("").length || 0;
    const existCodeCount =
      messageTitle.match(exceptJapaneseOrChineseRegex)?.join("").length || 0;

    if (
      incommingCharacterCount * CONSTANT_SET.CHAR_WIDTH +
        incomingCodeCount * CONSTANT_SET.LETTER_WIDTH +
        existCharacterCount * CONSTANT_SET.CHAR_WIDTH +
        existCodeCount * CONSTANT_SET.LETTER_WIDTH >
      messageTitleWidth
      //   ||
      // incommingCharacterCount > CONSTANT_SET.MAX_TITLE_CHARACTER ||
      // incomingCodeCount > CONSTANT_SET.MAX_TITLE_LETTER ||
      // existCharacterCount + incommingCharacterCount >
      //   CONSTANT_SET.MAX_TITLE_CHARACTER ||
      // existCodeCount + incomingCodeCount > CONSTANT_SET.MAX_TITLE_LETTER
    ) {
      e.preventDefault();
    }
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const res = checkInputLength(e.target.value, "message");
    // const cursorPos = e.target.selectionStart;
    if (
      !isMessagePaste &&
      res.incommingCharacterCount * CONSTANT_SET.MAX_MESSAGE_CHARACTER +
        res.incomingCodeCount * CONSTANT_SET.MAX_MESSAGE_letter <=
        CONSTANT_SET.MAX_MESSAGE_INPUT_WIDTH
    ) {
      if (
        res.incommingCharacterCount / CONSTANT_SET.MAX_MESSAGE_CHARACTER >
          CONSTANT_SET.MAX_MESSAGE_PROPORTION &&
        res.incomingCodeCount / CONSTANT_SET.MAX_MESSAGE_letter <
          CONSTANT_SET.MIN_MESSAGE_PROPORTION
      ) {
        setMessageMaxLength(CONSTANT_SET.MAX_MESSAGE_CHARACTER);
      } else {
        setMessageMaxLength(CONSTANT_SET.MAX_MESSAGE_letter);
      }
    }
    setMessage(e.target.value);
    setIsMessagePaste(false);
  };

  const handleMessagePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    setIsMessagePaste(true);
    setOriginMessage(message);
    // index cursorPosition
    const pasteData = e.clipboardData.getData("text");
    const paste_res = checkInputLength(pasteData, "message");

    if (
      (paste_res.incommingCharacterCount / CONSTANT_SET.MAX_MESSAGE_CHARACTER >
        CONSTANT_SET.MAX_MESSAGE_PROPORTION &&
        paste_res.incomingCodeCount / CONSTANT_SET.MAX_MESSAGE_letter <
          CONSTANT_SET.MIN_MESSAGE_PROPORTION) ||
      (paste_res.existCharacterCount / CONSTANT_SET.MAX_MESSAGE_CHARACTER >
        CONSTANT_SET.MAX_MESSAGE_PROPORTION &&
        paste_res.existCodeCount / CONSTANT_SET.MAX_MESSAGE_letter <
          CONSTANT_SET.MIN_MESSAGE_PROPORTION)
    ) {
      setMessageMaxLength(CONSTANT_SET.MAX_MESSAGE_CHARACTER);
    } else {
      setMessageMaxLength(CONSTANT_SET.MAX_MESSAGE_letter);
    }

    setIsMessagePaste(false);
    setMessage(message);
  };

  const checkInputLength = (value: string, type: string) => {
    let existCharacterCount;
    let existCodeCount;
    const incommingCharacterCount =
      value.match(includeJapaneseOrChineseRegex)?.join("").length || 0;
    const incomingCodeCount =
      value.match(exceptJapaneseOrChineseRegex)?.join("").length || 0;

    if (type === INPUT_TYPE_NAME.TITLE) {
      existCharacterCount =
        messageTitle.match(includeJapaneseOrChineseRegex)?.join("").length || 0;
      existCodeCount =
        messageTitle.match(exceptJapaneseOrChineseRegex)?.join("").length || 0;
    } else {
      existCharacterCount =
        message.match(includeJapaneseOrChineseRegex)?.join("").length || 0;
      existCodeCount =
        message.match(exceptJapaneseOrChineseRegex)?.join("").length || 0;
    }

    return {
      incommingCharacterCount: incommingCharacterCount,
      incomingCodeCount: incomingCodeCount,
      existCharacterCount: existCharacterCount,
      existCodeCount: existCodeCount,
    };
  };

  const LoadingComponent = () => {
    return (
      <React.Fragment>
        <Dialog open={openLoading}>
          <DialogTitle>Send Message</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {showSuccessIcon
                ? "The message has been sent successfully."
                : "Please wait a moment, the message is sending..."}
            </DialogContentText>
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                m: "auto",
                width: "fit-content",
              }}
            >
              {showSuccessIcon ? (
                <IconProgressCheck
                  stroke={2}
                  width={"40px"}
                  height={"40px"}
                  color="#4fa94d"
                />
              ) : (
                <ThreeDots
                  visible={true}
                  height="80"
                  width="80"
                  color="#4fa94d"
                  radius="9"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              )}
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  };

  const [prevValue, setPrevValue] = useState("");
  const handleFocus = (value: string) => {
    const incommingCharacterCount =
      value.match(includeJapaneseOrChineseRegex)?.join("").length || 0;
    const incomingCodeCount =
      value.match(exceptJapaneseOrChineseRegex)?.join("").length || 0;
    if (value && !(incommingCharacterCount === 6 || incomingCodeCount === 9)) {
      setPrevValue(currentMessageTitle);
    } else {
      console.log(value, "error value");
    }
  };

  const handleBlur = () => {
    setMessageTitle(currentMessageTitle);
  };

  return (
    <>
      {optionWidth && (
        <Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              component="h1"
              fontSize="1.3rem"
              fontWeight={400}
              color="rgba(0, 0, 0, 0.6)"
            >
              {REPORT_TITLE.SEND_MESSAGE}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            // spacing={3}
            alignItems="center"
            justifyContent="space-between"
            marginTop={"5px"}
            display={"block"}
          >
            <FormControl
              sx={{
                m: 1,
                minWidth: optionWidth,
                margin: 0,
                marginRight: "26px",
                marginBottom: "20px",
              }}
              size="medium"
            >
              <InputLabel id="dashboard-input-label">Dashboards</InputLabel>
              <Select
                labelId="dashboard-select-label"
                id="dashboard-select"
                value={currentDashboard}
                label="Dashboard"
                onChange={handleChange}
              >
                {dashboardList?.map(
                  (item: { DashboardId: string; Name: string }) => (
                    <MenuItem value={item.DashboardId}>
                      {item.Name ?? ""}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>

            <FormControl
              sx={{
                // minWidth: "248px",
                // display: "flex",
                width: "250px",
                marginBottom: "20px",
                ".css-16p630n-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root.Mui-disabled":
                  {
                    borderRadius: "4px",
                    ":before": {
                      borderBottomStyle: "unset",
                    },
                  },
              }}
            >
              <InputLabel
                id="demo-simple-select-label"
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                Devices
                <Fade
                  in={deviceLoading}
                  style={{
                    // color: "red",
                    width: "25px",
                    height: "25px",
                    marginLeft: "40px",
                    transitionDelay: deviceLoading ? "100ms" : "0ms",
                  }}
                  unmountOnExit
                >
                  <CircularProgress />
                </Fade>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={deviceId}
                label="Devices"
                disabled={deviceLoading || devices.length === 0}
                variant={devices.length === 0 ? "filled" : "outlined"}
                onChange={selectDeviceChange}
              >
                {devices.map((device) => (
                  <MenuItem key={device.DeviceId} value={device.DeviceId}>
                    {device.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <hr
              style={{
                // width: optionWidth,
                width: "45vw",
                display: "table-caption",
              }}
            />
          </Stack>

          <Grid2>
            <Grid2
              sx={{
                marginTop: "20px",
                marginBottom: "20px",
                ".css-19yj9db-MuiInputBase-root-MuiFilledInput-root.Mui-disabled":
                  {
                    borderRadius: "4px",
                    ":before": {
                      borderBottomStyle: "unset",
                    },
                  },
              }}
            >
              <Grid2>
                <TextField
                  id="title-text"
                  label="Title"
                  variant={!deviceId ? "filled" : "outlined"}
                  onChange={handleMessageTitleChange}
                  onPaste={handleMessageTitlePaste}
                  onFocus={(event) => handleFocus(event.target.value)}
                  onBlur={handleBlur}
                  value={messageTitle}
                  error={!messageTitle && showError}
                  disabled={!deviceId}
                  onCompositionStart={() => setIsComposing(false)}
                  onCompositionEnd={(event: any) => {
                    setIsComposing(true);
                    const incommingCharacterCount =
                      event.target.value
                        .match(includeJapaneseOrChineseRegex)
                        ?.join("").length || 0;
                    const incomingCodeCount =
                      event.target.value
                        .match(exceptJapaneseOrChineseRegex)
                        ?.join("").length || 0;
                    if (
                      incomingCodeCount === 0 &&
                      incommingCharacterCount <= 6
                    ) {
                      setMessageTitle(event.target.value);
                    } else {
                      if (
                        incommingCharacterCount * CONSTANT_SET.CHAR_WIDTH +
                          incomingCodeCount * CONSTANT_SET.LETTER_WIDTH <=
                        messageTitleWidth
                      ) {
                        setMessageTitle(event.target.value);
                      } else {
                        const latest_res = checkInputLength(
                          event.target.value,
                          "title",
                        );
                        const latest_remainingCount =
                          latest_res.incommingCharacterCount *
                            CONSTANT_SET.CHAR_WIDTH +
                          latest_res.incomingCodeCount *
                            CONSTANT_SET.LETTER_WIDTH -
                          CONSTANT_SET.MAX_INPUT_WIDTH;

                        const latest_remainingWidth = Math.floor(
                          latest_remainingCount / CONSTANT_SET.CHAR_WIDTH,
                        );
                        if (latest_remainingWidth > 0) {
                          setMessageTitle(
                            event.target.value.slice(0, -latest_remainingWidth),
                          );
                        } else {
                          setMessageTitle(event.target.value.slice(0, -1));
                        }
                      }
                    }

                    // listeningTitleInputchange(event);
                  }}
                  sx={{
                    width: "350px",
                    margin: "0",
                    marginRight: "2vw",
                    ".css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                      letterSpacing: "1px",
                    },
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <Tooltip
                          title={
                            <span
                              dangerouslySetInnerHTML={{
                                __html: messageTitleTooltip,
                              }}
                            ></span>
                          }
                          placement="top"
                        >
                          <InputAdornment position="end">
                            <IconInfoCircle stroke={2} />
                          </InputAdornment>
                        </Tooltip>
                      ),
                    },
                  }}
                />
                <FormHelperText
                  sx={{
                    width: "350px",
                    margin: "5px",
                    marginTop: "5px",
                    color: "#ff1744",
                  }}
                >
                  {!messageTitle && showError
                    ? "Please enter the title. It should not exceed 6 characters or 9 words."
                    : ""}
                </FormHelperText>
              </Grid2>
            </Grid2>

            <Grid2
              sx={{
                // marginTop: "20px",
                marginBottom: "20px",
                ".css-19yj9db-MuiInputBase-root-MuiFilledInput-root.Mui-disabled":
                  {
                    borderRadius: "4px",
                    ":before": {
                      borderBottomStyle: "unset",
                    },
                  },
              }}
            >
              <Grid2>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Message"
                  variant={!deviceId ? "filled" : "outlined"}
                  multiline
                  rows={3}
                  onChange={handleMessageChange}
                  onPaste={handleMessagePaste}
                  onClick={(e: any) => {
                    setCursorPosition(e.target.selectionStart);
                  }}
                  disabled={!deviceId}
                  error={!message && showError}
                  value={message}
                  sx={{
                    width: "350px",
                    margin: "0",
                    ".css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                      letterSpacing: "2px",
                    },
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <Tooltip
                          title={
                            <span
                              dangerouslySetInnerHTML={{
                                __html: messageTooltip,
                              }}
                            ></span>
                          }
                          placement="top"
                        >
                          <InputAdornment position="end">
                            <IconInfoCircle stroke={2} />
                          </InputAdornment>
                        </Tooltip>
                      ),
                    },
                    htmlInput: { maxLength: messageMaxLength },
                  }}
                />

                <FormHelperText
                  sx={{
                    width: "350px",
                    margin: "5px",
                    marginTop: "5px",
                    color: "#ff1744",
                  }}
                >
                  {!message && showError
                    ? "Please enter the messages. It should not exceed 33 characters or 50 words."
                    : ""}
                </FormHelperText>
              </Grid2>
            </Grid2>
          </Grid2>

          <LoadingButton
            sx={{ backgroundColor: "#009696" }}
            // color="success"
            size="large"
            onClick={sendMessage}
            endIcon={<SendIcon />}
            loading={messageLoading}
            loadingPosition="end"
            variant="contained"
            disabled={!deviceId || !currentDashboard}
          >
            Send
          </LoadingButton>
          <LoadingComponent />
        </Box>
      )}
    </>
  );
};
export default messagePage;
